import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { CollapseContentData } from '../types'

interface Props {
  collapseContentData: CollapseContentData
}

const LeftBlock = ({ collapseContentData }: Props) => {
  const description = collapseContentData.description

  return (
    <>
      {!!description && (
        <Box>
          <Text.Normal weight="medium" color="grey1000">
            {i18n.t('common.description')}
          </Text.Normal>
          <Text.Normal>{String(description)}</Text.Normal>
        </Box>
      )}
    </>
  )
}

export default LeftBlock
